import { render } from "./ColorText.vue?vue&type=template&id=c07f2210&ts=true"
import script from "./ColorText.vue?vue&type=script&lang=ts"
export * from "./ColorText.vue?vue&type=script&lang=ts"

import exportComponent from "/data/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__